import React from 'react';
import { motion } from 'framer-motion';
export function TrustBar() {
  return <section className="py-12 bg-white/50 border-y border-brand-cardPink/50" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="text-center mb-8" data-id="element-245">
          <p className="text-sm font-semibold text-brand-secondary uppercase tracking-wider" data-id="element-246">
            Basada en evidencia científica de:
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 mb-12 opacity-70 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-247">
          <span className="font-heading font-bold text-xl text-brand-dark" data-id="element-248">
            OMS
          </span>
          <span className="font-heading font-bold text-xl text-brand-dark" data-id="element-249">
            CDC
          </span>
          <span className="font-heading font-bold text-xl text-brand-dark" data-id="element-250">
            Ginecólogos Certificados
          </span>
          <span className="font-heading font-bold text-xl text-brand-dark" data-id="element-251">
            Evidencia Médica 2024
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center max-w-4xl mx-auto" data-id="element-252">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="p-6 rounded-2xl bg-brand-cardPink/30" data-id="element-253">
            <div className="text-3xl font-bold text-brand-primary mb-2" data-id="element-254">
              2,400+
            </div>
            <div className="text-brand-secondary font-medium" data-id="element-255">Mujeres</div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="p-6 rounded-2xl bg-brand-cardPurple/30" data-id="element-256">
            <div className="text-3xl font-bold text-brand-primary mb-2" data-id="element-257">
              45+
            </div>
            <div className="text-brand-secondary font-medium" data-id="element-258">Páginas</div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="p-6 rounded-2xl bg-brand-cardPink/30" data-id="element-259">
            <div className="text-3xl font-bold text-brand-primary mb-2" data-id="element-260">
              99%
            </div>
            <div className="text-brand-secondary font-medium" data-id="element-261">Recomiendan</div>
          </motion.div>
        </div>
      </div>
    </section>;
}